import * as React from 'react'
import styled from 'styled-components'
import Drawer from 'theme/atoms/Drawer'
import Button from 'theme/atoms/Button'
import theme from 'theme'
import useTranslations from 'hooks/useTranslations'
import CustomTailor from './CustomTailor/CustomTailor'
import DrawerHeader from './DrawerHeader/DrawerHeader'
import CloseIcon from 'assets/menu-close.svg'
import ColorFilter from './ColorFilter/ColorFilter'
import Filter from './Filter/Filter'
import * as events from './events'
import { usePDPFilterDrawerOpen } from 'modules/ui'

type Props = {
  'data-cy-state'?: string
}

export default function FilterDrawer(props: Props) {
  const { setOpen } = usePDPFilterDrawerOpen()
  const t = useTranslations<'templates-PDP'>()

  const handleClose = (type: 'x' | 'apply' | 'outside-click' | 'event') => {
    events.close(type)
    setOpen(false)
  }
  React.useEffect(() => {
    events.open()
  }, [])

  return (
    <Drawer
      hideOverlay
      visible={true}
      customHeader={true}
      onClose={() => handleClose('outside-click')}
      data-cy-handle-overlay="overlay"
      data-cy-collection="FilterDrawer"
      data-cy-state={props['data-cy-state']}
    >
      <Wrapper data-cy-collection="FilterDrawer">
        <div className="top-container">
          <DrawerHeader />
          <button
            className="close-container"
            onClick={() => handleClose('x')}
            data-cy-handle="close-drawer-btn"
          >
            <CloseIcon />
          </button>
        </div>
        <ColorFilter />
        <Filter filterKey="size" label="size_label" />
        <Filter filterKey="style" label="style_label" />
        <Filter filterKey="variant" label="variant_label" />
        <CustomTailor />
        <Button
          variation="primary"
          data-cy-handle="close"
          onClick={() => handleClose('apply')}
        >
          {t('filter_apply_btn')}
        </Button>
      </Wrapper>
    </Drawer>
  )
}

const Wrapper = styled.div`
  padding-bottom: 40px;

  > button {
    display: block;
    margin: 0 auto;
    width: 15rem;
    text-align: center;
    margin-top: ${theme.spacing('l')};

    @media screen and (min-width: ${theme.ms.MD}) {
      width: 100%;
    }
  }
  > .top-container {
    position: sticky;
    top: 0;
    background: ${theme.colors.white};
    z-index: ${theme.zIndex.theme_templates_pdp_filterdrawer};
    padding: ${theme.spacing('ml')};
    padding-bottom: 0;
    > .close-container {
      position: absolute;
      top: 30px;
      right: 30px;
      cursor: pointer;
    }
  }
`
